import {Route} from 'react-router-dom';
import MainPage from './pages/MainPage';
import GuidePage from './pages/GuidePage';
import GuidePageId from './pages/GuidePageId';
import Foreigns from './pages/Foreigns';
import InogorodnimPage from './pages/InogorodnimPage';
import InostrantsamPage from './pages/InostrantsamPage';
import TomichamPage from './pages/TomichamPage';

function App() {

  return (
    <>
      <Route path="/" exact component={MainPage}/>
      <Route path="/guide" exact component={GuidePage}/>
      <Route path="/guide/:id" component={GuidePageId}/>
      <Route path="/foreigns" component={Foreigns}/>
      <Route path="/inogorodnim" component={InogorodnimPage}/>
      <Route path="/inostrantsam" component={InostrantsamPage}/>
      <Route path="/tomicham" component={TomichamPage}/>
    </>
  );
}

export default App;
